import React, { useEffect, useState } from "react";
import { findPaymentPageLinkById, getLocationDetails, paymentPageSplitUp } from "../../api";
import PaymentPageDetails from "./components/PaymentPageDetails";
import Background from "../../assets/imgs/paymentpage-bg.png";
import '../../utils/reseponsive';
import getCountryPhoneCode from '../../utils/getCountryPhoneCode';
import * as moment from "moment-timezone";

type Props = {
  history: {
    push: Function,
  },
}

const PaymentPageIndex = (props: Props) => {

  const { match: { params: { id } }, location: { pathname } } = props;
  const [paymentPageLink, setPaymentPageLink] = useState(null);
  const [paymentPageMeta, setPaymentPageMeta] = useState(null);
  const [account, setAccount] = useState(null);
  const [phoneCode, setPhoneCode] = useState(null);
  const [countryData, setCountryData] = useState('');
  const qnty = [];
  const fixed = [];
  const custDecide = [];
  const [showTipError, setShowTipError] = useState(false);
  const [showComboError, setShowComboError] = useState(false);
  const [showPromoError, setPromoError] = useState(false);
  const [showHoursError, setHoursError] = useState(false);
  const [showCustomMinMaxError, setShowCustomMinMaxError] = useState(false);
  let comboData;
  let comboBoxId;
  const comboFinalData = {};

  useEffect(() => {
    if (id) {
      localStorage.removeItem(id);
      localStorage.removeItem('quantity');
      localStorage.removeItem('tipValue');
      localStorage.removeItem('fixedAmountVal');
      localStorage.removeItem('customerDesideVal');
      localStorage.removeItem('itemQuantity');
      localStorage.removeItem('itemFixed');
      localStorage.removeItem('itemCustDecide');
      localStorage.removeItem('comboboxAddon');
      localStorage.removeItem('comboboxLength');
      const storageName = "comboboxValidate";
      const storageKeys = Object.keys(sessionStorage);
      for (const key of storageKeys) {
        if (key.startsWith(storageName)) {
          sessionStorage.removeItem(key);
        }
      }
    }
    //getDefaultCountryPostal();
    getPaymentPageMetaById();
  }, [id]);

  const getDefaultCountryPostal = async () => {
    try {
      const data = await getLocationDetails();
      setCountryData(data && data.country_calling_code);
    } catch (e) {
      console.log(e);
    }
  };

  const getPaymentPageMetaById = async () => {
    if (id) {
      try {
        const value = await findPaymentPageLinkById(id);
        if (value) {
          setPaymentPageLink(value);
          setPaymentPageMeta(value.paymentPageMeta);
          setAccount(value.account);
          setPhoneCode(getCountryPhoneCode(value.account && value.account.country && value.account.country.id));
        }
      } catch (e) {
        props.history.push(`${pathname}/error`);
      }
    }
  };

  useEffect(() => {
    document.body.style.backgroundImage = `url(${Background})`
  }, []);

  const onSubmit = async data => {
    const { hoursOfOperation } = account;
    const { enableHoursOfOperation } = account;
    const { timezone } = account;
    const tempGid = account.gid;

    //custom validation
    const customAccGid = [
      "",
    ];
    if (customAccGid.includes(tempGid)) {
      let tickets = 0;
      Object.keys(data).forEach(function (key) {
        // console.log(`Key ${key} value ${data[key]} typeof ${typeof(data[key])}`);
        if (typeof (data[key]) === 'number') {
          tickets += data[key];
        }
      })
      // console.log(`Total tickets ${tickets}`);
      if (tickets !== 10) {
        setShowCustomMinMaxError(true);
        return false;
      } else {
        setShowCustomMinMaxError(false);
      }
    }
    //remove later

    if (enableHoursOfOperation && hoursOfOperation) {
      const today = moment.utc(new Date()).tz(timezone);
      const days = ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'];
      const day = days[today._i.getDay()];
      const minutes = (today._i.getHours() * 60) + (today._i.getMinutes());
      const currentDay = hoursOfOperation && hoursOfOperation.filter((weekDay) => weekDay.dayOfWeek === day);
      if (currentDay && currentDay[0].openingTime > minutes) {
        setHoursError(true);
        return false;
      } else if (currentDay && currentDay[0].closingTime <= minutes) {
        setHoursError(true);
        return false;
      }
    }
    const accGid = [
      "account-ff1166de992e429c82eb02f86dfdbbab",
      "account-ee13cf50fea3429db080b57385445247"
    ];
    let comboInfo;
    if (accGid.includes(tempGid)) {
      comboInfo = (paymentPageMeta && paymentPageMeta.paymentPageMetaFields).filter((data) => (data.type === "COMBO_BOX"));
    } else {
      comboInfo = (paymentPageMeta && paymentPageMeta.paymentPageMetaFields).filter((data) => (data.type === "COMBO_BOX") && (data.isRequired));
    }
    let comboParents;
    const newValidationArray = [];
    const validateCombo = (comboInfo && comboInfo.length > 0) ? comboInfo.map((res) => {
      comboParents = Object.keys(data).filter(key => key.includes(`${res.gid}#child`));
      const comboRes = comboParents && comboParents.map(parentKey => {
        const parentObj = data[parentKey];
        const label = parentObj && parentObj.label ? parentObj.label : false;
        const childKey = parentKey.replace('#parent', '#child');
        const childObj = data[childKey];
        const childLabel = childObj && childObj.label ? childObj.label : false;
        return newValidationArray.push(label, childLabel);
      });
    }) : null;
    if (newValidationArray && newValidationArray.includes(false)) {
      setShowComboError(true);
      return false;
    }
    const validateRequiredCombo = (paymentPageMeta && paymentPageMeta.paymentPageMetaFields).filter((data) => data.type === "PRICE_AMOUNT_QUANTITY_BASED" && (data.isComboBoxRequired === true));
    let validationArr = [];
    const newArrayss = validateRequiredCombo.map((res, id) => {
      let comboDataSet = comboFinalData[`${res.gid}`];
      const comboboxInfo = sessionStorage.getItem(`comboboxValidate${res.gid}`);
      if (JSON.parse(comboboxInfo) && JSON.parse(comboboxInfo).length !== 0) {
        validationArr.push(JSON.parse(comboboxInfo));
      }
    })
    if (validationArr.length === validateRequiredCombo.length) {
      setShowComboError(false);
    } else {
      setShowComboError(true);
      return false;
    }
    const validateRequiredCombo1 = (paymentPageMeta && paymentPageMeta.paymentPageMetaFields).filter((data) => data.type === "PRICE_AMOUNT_FIXED" && (data.isComboBoxRequired === true));
    let validationArr1 = [];
    const newArrayss1 = validateRequiredCombo1.map((res, id) => {
      const parentKeys = Object.keys(data).filter(key => key.includes(`${res.gid}#child`));
      const results = parentKeys && parentKeys.map(parentKey => {
        console.log(data[parentKey], 'itemIndex');
        if (data[parentKey]) {
          validationArr1.push(true);
        } else {
          validationArr1.push(false);
        }
      });
    })
    function hasTrueValue(array) {
      return array.some(item => item === true);
    }
    if (validateRequiredCombo1 && validateRequiredCombo1.length !== 0) {
      if ((validationArr1.length >= 1) && (hasTrueValue(validationArr1))) {
        setShowComboError(false);
      } else {
        setShowComboError(true);
        return false;
      }
    }
    const tipInfo = (paymentPageMeta && paymentPageMeta.paymentPageMetaFields).filter((data) => data.type === "TIP");
    const typeEmail = (paymentPageMeta && paymentPageMeta.paymentPageMetaFields).filter((data) => data.type === "INPUT_EMAIL");
    const typeMobile = (paymentPageMeta && paymentPageMeta.paymentPageMetaFields).filter((data) => data.type === "INPUT_PHONE");
    const email = typeEmail && typeEmail[0].gid;
    const phone = typeMobile && typeMobile[0].gid;
    const code = typeMobile && `${typeMobile[0].gid}#code`;
    const callingCode = data[code] && data[code].value;
    const customerFields = {
      contactUsEmail: (data && data[email]) || null,
      contactUsPhone: data && `${callingCode}${data[phone]}`,
    };
    localStorage.setItem('customerFields', JSON.stringify(customerFields));
    generateData(data);
    const promoCodeInfo = generatePromoData(data);
    const { gid } = paymentPageMeta;
    const promoInfo = (paymentPageMeta && paymentPageMeta.paymentPageMetaFields).filter((data) => data.type === "PROMOTIONAL_CODES");
    const proGid = (promoInfo && promoInfo.length > 0) ? promoInfo[0].gid : null;
    if (promoInfo && promoInfo.length > 0) {
      promoInfo[0].value = data[proGid];
    }
    if (promoInfo && promoInfo.length > 0) {
      try {
        const value = await paymentPageSplitUp(gid, promoCodeInfo);
        if (value) {
          setPromoError(false);
          if (tipInfo && tipInfo.length > 0) {
            if (tipInfo && tipInfo[0].isRequired) {
              if (data[tipInfo[0].gid] === 0) {
                setShowTipError(true);
              } else if (data[tipInfo[0].gid] !== 0) {
                if (props.history) {
                  props.history.push(props.history.location && props.history.location.pathname + '/pay');
                }
              }
            } else {
              if (props.history) {
                props.history.push(props.history.location && props.history.location.pathname + '/pay');
              }
            }
          } else {
            if (props.history) {
              props.history.push(props.history.location && props.history.location.pathname + '/pay');
            }
          }
        } else {
          setPromoError(true);
        }
      } catch (reason) {
        console.error(reason);
        setPromoError(true);
      }
      return false;
    } else {
      if (tipInfo && tipInfo.length > 0) {
        if (tipInfo && tipInfo[0].isRequired) {
          if (data[tipInfo[0].gid] === 0) {
            setShowTipError(true);
          } else if (data[tipInfo[0].gid] !== 0) {
            if (props.history) {
              props.history.push(props.history.location && props.history.location.pathname + '/pay');
            }
          }
        } else {
          if (props.history) {
            props.history.push(props.history.location && props.history.location.pathname + '/pay');
          }
        }
      } else {
        if (props.history) {
          props.history.push(props.history.location && props.history.location.pathname + '/pay');
        }
      }
    }

  };

  const getComboInfo = (list, id) => {
    comboFinalData[`${id}`] = list;
    comboData = list;
    comboBoxId = id;
  };

  const sliceIntoChunks = (arr, chunkSize) => {
    const res = [];
    for (let i = 0; i < arr.length; i += chunkSize) {
      const chunk = arr.slice(i, i + chunkSize);
      res.push(chunk);
    }
    return res;
  }

  const generateData = data => {
    let paymentPageEntries = [];
    let totalAmount = 0;
    const comboboxInfo = localStorage.getItem('comboboxAddon');
    JSON.stringify(comboboxInfo);
    paymentPageMeta && paymentPageMeta.paymentPageMetaFields && paymentPageMeta.paymentPageMetaFields.map(meta => {
      let obj = {
        paymentPageMetaFieldGid: meta.gid,
        type: meta.type,
        label: meta.label,
        description: meta.description,
        value: data[meta.gid]
      };
      if (meta.type === 'INPUT_PHONE') {
        const number = data[meta.gid];
        const code = data[`${meta.gid}#code`];
        const value = code && code.value && `${code.value}${number}`;
        obj = {
          ...obj,
          value
        }
      }
      if (meta.type === 'PRICE_AMOUNT_QUANTITY_BASED') {
        const quantityBasedValue = parseInt(data[meta.gid]) || 0;
        localStorage.setItem('quantity', quantityBasedValue);
        const itemLength = localStorage.getItem('comboboxLength');
        let comboDataSet = comboFinalData[`${meta.gid}`];
        const lengthCheck = meta.comboBox && meta.comboBox.length;
        let comboTestCheck;
        if (comboDataSet === undefined) {
          comboTestCheck = sessionStorage.getItem(`comboboxValidate${meta.gid}`);
        };
        const list = comboDataSet && comboDataSet.length !== 0 ? [...comboDataSet] : comboTestCheck && comboTestCheck.length !== 0 ? [...JSON.parse(comboTestCheck)] : [];
        const finalComboData = sliceIntoChunks(list, lengthCheck);
        const finalComboBox = [];
        let testObject = {};
        let amount = 0;
        for (let i = 0; i < finalComboData.length; i += 1) {
          for (let j = 0; j < finalComboData[i].length; j += 1) {
            amount += finalComboData[i][j].price ? finalComboData[i][j].price : 0;
            const label = finalComboData[i][j].label;
            testObject[`${label}`] = finalComboData[i][j].type ? finalComboData[i][j].type : "";
            testObject['additionalPrice'] = amount ? amount : 0;
            testObject['isRedeemed'] = false;
          }
          finalComboBox.push(testObject);
          amount = 0;
          testObject = {};
        }
        obj = {
          ...obj,
          value: quantityBasedValue,
          comboBoxValue: meta.comboBox ? (finalComboBox.length > 0 ? finalComboBox : null) : null,
        };
        totalAmount += quantityBasedValue * meta.amount;
        qnty.push(quantityBasedValue);
        localStorage.setItem('itemQuantity', JSON.stringify(qnty));
      }
      if (meta.type === 'PRICE_AMOUNT_CUSTOMER_DECIDED') {
        const customerDecidedValue = (data[meta.gid] && Math.round(parseFloat(data[meta.gid]) * 100)) || 0;
        obj = {
          ...obj,
          value: customerDecidedValue
        };
        totalAmount += customerDecidedValue;
        custDecide.push(customerDecidedValue);
        localStorage.setItem('itemCustDecide', JSON.stringify(custDecide));
        localStorage.setItem('customerDesideVal', true);
      }
      if (meta.type === 'PRICE_AMOUNT_FIXED') {
        const parentKeys = Object.keys(data).filter(key => key.includes(`${meta.gid}#child`));
        const results = parentKeys && parentKeys.map(parentKey => {
          const itemIndex = parentKey.split('child')[1];
          const comboLabel = meta.comboBox[Number(itemIndex)].value;
          const childKey = parentKey.replace('#parent', '#child');
          const childObj = data[childKey];
          const childLabel = childObj && childObj.label ? childObj.label : '';
          const val = {};
          const key = comboLabel;
          const value = childLabel;
          val[key] = value;
          return val;

        });
        let comboresults;
        if (results && results.length > 0) {
          comboresults = results.reduce((accumulator, currentObject) => {
            return { ...accumulator, ...currentObject };
          }, {});
        }
        let amountFixedValue = 0;
        if (data[meta.gid]) { amountFixedValue = meta.amount; }
        obj = {
          ...obj,
          value: amountFixedValue,
          comboBoxValue: comboresults ? [comboresults] : null,
        };
        totalAmount += amountFixedValue;
        fixed.push(amountFixedValue);
        localStorage.setItem('itemFixed', JSON.stringify(fixed));
        localStorage.setItem('fixedVal', amountFixedValue);
        localStorage.setItem('fixedAmountVal', true);
      }
      if (meta.type === 'COMBO_BOX') {
        const parentKeys = Object.keys(data).filter(key => key.includes(`${meta.gid}#child`));
        const results = parentKeys && parentKeys.map(parentKey => {
          const itemIndex = parentKey.split('child')[1];
          const comboLabel = meta.comboBox[Number(itemIndex)].value;
          const parentObj = data[parentKey];
          const label = parentObj && parentObj.label ? parentObj.label : '';
          const childKey = parentKey.replace('#parent', '#child');
          const childObj = data[childKey];
          const childLabel = childObj && childObj.label ? childObj.label : '';
          const val = {};
          const key = comboLabel;
          const value = childLabel;
          val[key] = value;
          return val;
        });
        let comboboxresults;
        if (results && results.length > 0) {
          comboboxresults = results.reduce((accumulator, currentObject) => {
            return { ...accumulator, ...currentObject };
          }, {});
        }
        // const resultString = results.filter(res => res !== null).join(' && ');
        const value = null;
        obj = {
          ...obj,
          comboBoxValue: comboboxresults ? [comboboxresults] : null,
          value
        }
      }
      if (meta.type === 'TIP') {
        const tipAmount = data[meta.gid];
        const value = tipAmount ? (tipAmount * 100) : null;
        obj = {
          ...obj,
          value
        }
        localStorage.setItem('tipValue', value);
      }
      if (meta.type === 'PROMOTIONAL_CODES') {
        const procode = data[meta.gid];
        obj = {
          ...obj,
          value: procode || null
        }
      }
      paymentPageEntries.push(obj);
    });
    localStorage.setItem(id, JSON.stringify({ paymentPageLink, paymentPageEntries, totalAmount }));
  };

  const generatePromoData = data => {
    let promoCodeValidateEntries = [];
    let totalAmount = 0;
    paymentPageMeta && paymentPageMeta.paymentPageMetaFields && paymentPageMeta.paymentPageMetaFields.map(meta => {
      let obj = {
        paymentPageMetaFieldGid: meta.gid,
        type: meta.type,
        label: meta.label,
        description: meta.description,
        value: data[meta.gid]
      };
      if (meta.type === 'INPUT_PHONE') {
        const number = data[meta.gid];
        const code = data[`${meta.gid}#code`];
        const value = code && code.value && `${code.value}${number}`;
        obj = {
          ...obj,
          value
        }
      }
      if (meta.type === 'PRICE_AMOUNT_QUANTITY_BASED') {
        const quantityBasedValue = parseInt(data[meta.gid]) || 0;
        const itemLength = localStorage.getItem('comboboxLength');
        const lengthCheck = meta.comboBox && meta.comboBox.length;
        let comboDataSet = comboFinalData[`${meta.gid}`];
        const list = comboDataSet && comboDataSet.length !== 0 ? [...comboDataSet] : [];
        const finalComboData = sliceIntoChunks(list, lengthCheck);
        const finalComboBox = [];
        let testObject = {};
        let amount = 0;
        for (let i = 0; i < finalComboData.length; i += 1) {
          for (let j = 0; j < finalComboData[i].length; j += 1) {
            amount += finalComboData[i][j].price;
            const label = finalComboData[i][j].label;
            testObject[`${label}`] = finalComboData[i][j].type;
            testObject[`${label}`] = finalComboData[i][j].type ? finalComboData[i][j].type : "";
            testObject['additionalPrice'] = amount ? amount : 0;
            testObject['isRedeemed'] = false;
          }
          finalComboBox.push(testObject);
          amount = 0;
          testObject = {};
        }
        obj = {
          ...obj,
          value: quantityBasedValue,
          comboBoxValue: meta.comboBox ? (finalComboBox.length > 0 ? finalComboBox : null) : null,
        };
        totalAmount += quantityBasedValue * meta.amount;
      }
      if (meta.type === 'PRICE_AMOUNT_CUSTOMER_DECIDED') {
        const customerDecidedValue = (data[meta.gid] && Math.round(parseFloat(data[meta.gid]) * 100)) || 0;
        obj = {
          ...obj,
          value: customerDecidedValue
        };
        totalAmount += customerDecidedValue;
      }
      if (meta.type === 'PRICE_AMOUNT_FIXED') {
        const parentKeys = Object.keys(data).filter(key => key.includes(`${meta.gid}#child`));
        const results = parentKeys && parentKeys.map(parentKey => {
          const itemIndex = parentKey.split('child')[1];
          const comboLabel = meta.comboBox[Number(itemIndex)].value;
          const childKey = parentKey.replace('#parent', '#child');
          const childObj = data[childKey];
          const childLabel = childObj && childObj.label ? childObj.label : '';
          const val = {};
          const key = comboLabel;
          const value = childLabel;
          val[key] = value;
          return val;

        });
        let comboresults;
        if (results && results.length > 0) {
          comboresults = results.reduce((accumulator, currentObject) => {
            return { ...accumulator, ...currentObject };
          }, {});
        }
        let amountFixedValue = 0;
        if (data[meta.gid]) { amountFixedValue = meta.amount; }
        obj = {
          ...obj,
          value: amountFixedValue,
          comboBoxValue: comboresults ? [comboresults] : null,
        };
        totalAmount += amountFixedValue;
      }
      if (meta.type === 'COMBO_BOX') {
        const parentKeys = Object.keys(data).filter(key => key.includes(`${meta.gid}#child`));
        const results = parentKeys && parentKeys.map(parentKey => {
          const itemIndex = parentKey.split('child')[1];
          const comboLabel = meta.comboBox[Number(itemIndex)].value;
          const parentObj = data[parentKey];
          const label = parentObj && parentObj.label ? parentObj.label : '';
          const childKey = parentKey.replace('#parent', '#child');
          const childObj = data[childKey];
          const childLabel = childObj && childObj.label ? childObj.label : '';
          if (label && childLabel) {
            return `${comboLabel}, ${childLabel}`;
          } if (label && !childLabel) {
            return `${comboLabel}`;
          } if (!label && childLabel) {
            return `${childLabel}`;
          } else return null;
        });
        const resultString = results.filter(res => res !== null).join(' && ');
        const value = resultString || '';
        obj = {
          ...obj,
          value
        }
      }
      if (meta.type === 'TIP') {
        const tipAmount = data[meta.gid];
        const value = tipAmount ? (tipAmount * 100) : 0;
        obj = {
          ...obj,
          value
        }
      }
      if (meta.type === 'PROMOTIONAL_CODES') {
        const procode = data[meta.gid];
        obj = {
          ...obj,
          value: procode || null
        }
      }
      promoCodeValidateEntries.push(obj);
    });
    return promoCodeValidateEntries;
  };

  return (
    <div className="px-3 px-lg-5 h-auto" style={{ background: paymentPageMeta && paymentPageMeta.primaryColor, minHeight: '100vh', paddingTop: '15px', paddingBottom: '15rem' }}>
      <PaymentPageDetails
        paymentPageMeta={paymentPageMeta}
        onSubmit={onSubmit}
        phoneCode={phoneCode}
        account={account}
        isPreview={false}
        isAdaptive={false}
        showTipError={showTipError}
        gid={account && account.gid}
        paymentHeading={paymentPageMeta && paymentPageMeta.paymentHeading}
        showPromoError={showPromoError}
        showHoursError={showHoursError}
        showComboError={showComboError}
        showCustomMinMaxError={showCustomMinMaxError}
        getComboInfo={getComboInfo}
      />
    </div>
  )
};

export default PaymentPageIndex
